






































































































import { Vue, Component, Prop } from "@/shared/vuepack";
import { BulkFileUploadStatus, bulkFileUploadStatusMap, BulkFileUploadType } from "@/admin/types";
import moment from "moment";
import { usePartnerStore } from "@/admin/store/partner";
import { Location } from "vue-router";
import { usePageSizeStore } from "@/shared/store/pageSize";

const initialSearchTerms = {
  fileName: "",
  startDate: "",
  endDate: "",
  status: BulkFileUploadStatus.None
};
@Component({
  computed: {
    bulkFileUploadStatusMap () {
      return bulkFileUploadStatusMap;
    }
  }
})
export default class PartnerUserFileSearch extends Vue {
  searchTerm = { ...initialSearchTerms };
  currentSearchTerm = { ...initialSearchTerms };

  currentDate = new Date();


  partnerStore = usePartnerStore();
  pageSizeStore = usePageSizeStore();

  @Prop()
  pageNumber: number;
  @Prop()
  fileType: BulkFileUploadType;
  @Prop()
  routeToBulkAddView: (page: number) => Location;

  statusOptions = BulkFileUploadStatus;
  isSubmitting = false;

  endDateValidator = {
    getMessage () {
      return "Date must be after the start date.";
    },
    validate (toDate, args) {
      if (args[0].length === 0) {
        return true;
      }
      return toDate ? moment(toDate) >= moment(args[0]) : false;
    }
  };

  fileNameValidator = {
    getMessage () {
      return "FileName can only contain letters, numbers, spaces, or periods.";
    },
    validate (input: string) {
      const regex = /^[a-zA-Z0-9 .]+$/;
      return regex.test(input);
    }
  };

  mounted () {
    this.$validator.extend("endDateValidator", this.endDateValidator);
    this.$validator.extend("fileNameValidator", this.fileNameValidator);
  }

  get hasStartDate () {
    return this.searchTerm.startDate.length !== 0;
  }

  get isFormValid () {
    return !this.$validator.errors.any();
  }

  get isSearchDisabled () {
    return this.isSubmitting === true || !this.isFormValid;
  }

  get isClearDisabled () {
    return this.isSubmitting === true;
  }

  onSearch (reset = false): void {
    if (this.isSubmitting) return;
    this.$validator
        .validate()
        .then(result => {
          if (!result) return;
          this.isSubmitting = true;
          if (reset) {
            this.pageNumber = 1;
            this.routeToBulkAddView(1);
          }
          else {
            this.searchTerm = {...this.currentSearchTerm};
          }
          this.partnerStore.searchBulkFiles(this.pageNumber,
              this.pageSizeStore.pageSize,
              this.fileType,
              this.searchTerm.fileName,
              this.searchTerm.status,
              this.searchTerm.startDate,
              this.searchTerm.endDate);
        }).finally(() => {
          this.isSubmitting = false;
          this.currentSearchTerm = {...this.searchTerm};
        });
  }
  clearSearch (): void {
    if (!this.isSubmitting) {
      this.pageNumber = 1;
      this.routeToBulkAddView(1);

      this.searchTerm = {...initialSearchTerms};
      this.currentSearchTerm = {...initialSearchTerms};

      this.partnerStore.searchBulkFiles(this.pageNumber,
          this.pageSizeStore.pageSize,
          this.fileType,
          this.searchTerm.fileName,
          this.searchTerm.status,
          this.searchTerm.startDate,
          this.searchTerm.endDate);
    }
  }

}
